//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IOpenApiClient {
    /**
     * @return OK
     */
    abms(): Observable<AbmDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    near(body: DigitalEquipmentRequest | undefined): Observable<DigitalEquipmentDto[]>;
    /**
     * @return OK
     */
    all(): Observable<DigitalEquipmentDto[]>;
    /**
     * @param assetId (optional) 
     * @return OK
     */
    digitalEquipment(assetId: string | undefined): Observable<DigitalEquipmentDto>;
    /**
     * @return OK
     */
    digitalRoadwork(roadworkId: string): Observable<DigitalRoadworkDto[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    start(body: DigitalRoadworkDto[] | undefined): Observable<DigitalRoadworkDto[]>;
    /**
     * @return OK
     */
    disallowAutomaticCloseForLongTermRoadwork(roadworkId: string): Observable<IdDto>;
    /**
     * @return OK
     */
    dismantle(roadworkId: string): Observable<IdDto>;
    /**
     * @return OK
     */
    interrupt(roadworkId: string): Observable<IdDto>;
    /**
     * @return OK
     */
    finish(roadworkId: string): Observable<IdDto>;
    /**
     * @return Created
     */
    unassignable(roadworkId: string): Observable<IdDto>;
    /**
     * @return Created
     */
    unassign(roadworkId: string): Observable<IdDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DigitalRoadworkDto[] | undefined): Observable<DigitalRoadworkDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    logger(body: LogErrorDto | undefined): Observable<RoadworkDto[]>;
    /**
     * @return OK
     */
    monitoring(): Observable<MonitoringReport>;
    /**
     * @return OK
     */
    notifications(): Observable<NotificationDto[]>;
    /**
     * @param km (optional) 
     * @param road (optional) 
     * @param direction (optional) 
     * @return OK
     */
    roadCoordinate(km: number | undefined, road: string | undefined, direction: number | undefined): Observable<RoadCoordinateDto>;
    /**
     * @return OK
     */
    roads(): Observable<RoadDto[]>;
    /**
     * @param abm (optional) 
     * @param roadway (optional) 
     * @param rfb (optional) 
     * @return OK
     */
    roadworks(abm: string | undefined, roadway: string | undefined, rfb: number | undefined): Observable<RoadworkDto[]>;
    /**
     * @param assetId (optional) 
     * @return OK
     */
    nearestRoadworks(assetId: string | undefined): Observable<RoadworkDto[]>;
    /**
     * @param roadworkId (optional) 
     * @return OK
     */
    sections(roadworkId: string | undefined): Observable<RoadworkSectionDto[]>;
    /**
     * @param appType (optional) 
     * @return OK
     */
    login(appType: string | undefined, body: LoginRequest): Observable<UserDto>;
    /**
     * @param appType (optional) 
     * @return OK
     */
    refreshtoken(appType: string | undefined): Observable<UserDto>;
    /**
     * @param appType (optional) 
     * @return OK
     */
    logout(appType: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class OpenApiClient implements IOpenApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    abms(): Observable<AbmDto[]> {
        let url_ = this.baseUrl + "/api/v1/Abms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbmDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbmDto[]>;
        }));
    }

    protected processAbms(response: HttpResponseBase): Observable<AbmDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AbmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    near(body: DigitalEquipmentRequest | undefined): Observable<DigitalEquipmentDto[]> {
        let url_ = this.baseUrl + "/api/v1/DigitalEquipment/near";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigitalEquipmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigitalEquipmentDto[]>;
        }));
    }

    protected processNear(response: HttpResponseBase): Observable<DigitalEquipmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DigitalEquipmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    all(): Observable<DigitalEquipmentDto[]> {
        let url_ = this.baseUrl + "/api/v1/DigitalEquipment/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigitalEquipmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigitalEquipmentDto[]>;
        }));
    }

    protected processAll(response: HttpResponseBase): Observable<DigitalEquipmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DigitalEquipmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return OK
     */
    digitalEquipment(assetId: string | undefined): Observable<DigitalEquipmentDto> {
        let url_ = this.baseUrl + "/api/v1/DigitalEquipment?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDigitalEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDigitalEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigitalEquipmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigitalEquipmentDto>;
        }));
    }

    protected processDigitalEquipment(response: HttpResponseBase): Observable<DigitalEquipmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DigitalEquipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    digitalRoadwork(roadworkId: string): Observable<DigitalRoadworkDto[]> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/{roadworkId}";
        if (roadworkId === undefined || roadworkId === null)
            throw new Error("The parameter 'roadworkId' must be defined.");
        url_ = url_.replace("{roadworkId}", encodeURIComponent("" + roadworkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDigitalRoadwork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDigitalRoadwork(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigitalRoadworkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigitalRoadworkDto[]>;
        }));
    }

    protected processDigitalRoadwork(response: HttpResponseBase): Observable<DigitalRoadworkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DigitalRoadworkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    start(body: DigitalRoadworkDto[] | undefined): Observable<DigitalRoadworkDto[]> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigitalRoadworkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigitalRoadworkDto[]>;
        }));
    }

    protected processStart(response: HttpResponseBase): Observable<DigitalRoadworkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(DigitalRoadworkDto.fromJS(item));
            }
            else {
                result201 = <any>null;
            }
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    disallowAutomaticCloseForLongTermRoadwork(roadworkId: string): Observable<IdDto> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/disallowAutomaticCloseForLongTermRoadwork/{roadworkId}";
        if (roadworkId === undefined || roadworkId === null)
            throw new Error("The parameter 'roadworkId' must be defined.");
        url_ = url_.replace("{roadworkId}", encodeURIComponent("" + roadworkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisallowAutomaticCloseForLongTermRoadwork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisallowAutomaticCloseForLongTermRoadwork(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdDto>;
        }));
    }

    protected processDisallowAutomaticCloseForLongTermRoadwork(response: HttpResponseBase): Observable<IdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    dismantle(roadworkId: string): Observable<IdDto> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/dismantle/{roadworkId}";
        if (roadworkId === undefined || roadworkId === null)
            throw new Error("The parameter 'roadworkId' must be defined.");
        url_ = url_.replace("{roadworkId}", encodeURIComponent("" + roadworkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismantle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismantle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdDto>;
        }));
    }

    protected processDismantle(response: HttpResponseBase): Observable<IdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    interrupt(roadworkId: string): Observable<IdDto> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/interrupt/{roadworkId}";
        if (roadworkId === undefined || roadworkId === null)
            throw new Error("The parameter 'roadworkId' must be defined.");
        url_ = url_.replace("{roadworkId}", encodeURIComponent("" + roadworkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInterrupt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInterrupt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdDto>;
        }));
    }

    protected processInterrupt(response: HttpResponseBase): Observable<IdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    finish(roadworkId: string): Observable<IdDto> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/finish/{roadworkId}";
        if (roadworkId === undefined || roadworkId === null)
            throw new Error("The parameter 'roadworkId' must be defined.");
        url_ = url_.replace("{roadworkId}", encodeURIComponent("" + roadworkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdDto>;
        }));
    }

    protected processFinish(response: HttpResponseBase): Observable<IdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created
     */
    unassignable(roadworkId: string): Observable<IdDto> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/unassignable/{roadworkId}";
        if (roadworkId === undefined || roadworkId === null)
            throw new Error("The parameter 'roadworkId' must be defined.");
        url_ = url_.replace("{roadworkId}", encodeURIComponent("" + roadworkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdDto>;
        }));
    }

    protected processUnassignable(response: HttpResponseBase): Observable<IdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = IdDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created
     */
    unassign(roadworkId: string): Observable<IdDto> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/unassign/{roadworkId}";
        if (roadworkId === undefined || roadworkId === null)
            throw new Error("The parameter 'roadworkId' must be defined.");
        url_ = url_.replace("{roadworkId}", encodeURIComponent("" + roadworkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdDto>;
        }));
    }

    protected processUnassign(response: HttpResponseBase): Observable<IdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = IdDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: DigitalRoadworkDto[] | undefined): Observable<DigitalRoadworkDto[]> {
        let url_ = this.baseUrl + "/api/v1/DigitalRoadwork/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigitalRoadworkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigitalRoadworkDto[]>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DigitalRoadworkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DigitalRoadworkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    logger(body: LogErrorDto | undefined): Observable<RoadworkDto[]> {
        let url_ = this.baseUrl + "/api/v1/Logger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoadworkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoadworkDto[]>;
        }));
    }

    protected processLogger(response: HttpResponseBase): Observable<RoadworkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoadworkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    monitoring(): Observable<MonitoringReport> {
        let url_ = this.baseUrl + "/api/v1/Monitoring";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonitoring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonitoring(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitoringReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitoringReport>;
        }));
    }

    protected processMonitoring(response: HttpResponseBase): Observable<MonitoringReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitoringReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    notifications(): Observable<NotificationDto[]> {
        let url_ = this.baseUrl + "/api/v1/Notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto[]>;
        }));
    }

    protected processNotifications(response: HttpResponseBase): Observable<NotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param km (optional) 
     * @param road (optional) 
     * @param direction (optional) 
     * @return OK
     */
    roadCoordinate(km: number | undefined, road: string | undefined, direction: number | undefined): Observable<RoadCoordinateDto> {
        let url_ = this.baseUrl + "/api/v1/RoadCoordinate?";
        if (km === null)
            throw new Error("The parameter 'km' cannot be null.");
        else if (km !== undefined)
            url_ += "km=" + encodeURIComponent("" + km) + "&";
        if (road === null)
            throw new Error("The parameter 'road' cannot be null.");
        else if (road !== undefined)
            url_ += "road=" + encodeURIComponent("" + road) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoadCoordinate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoadCoordinate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoadCoordinateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoadCoordinateDto>;
        }));
    }

    protected processRoadCoordinate(response: HttpResponseBase): Observable<RoadCoordinateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoadCoordinateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    roads(): Observable<RoadDto[]> {
        let url_ = this.baseUrl + "/api/v1/Roads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoadDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoadDto[]>;
        }));
    }

    protected processRoads(response: HttpResponseBase): Observable<RoadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoadDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param abm (optional) 
     * @param roadway (optional) 
     * @param rfb (optional) 
     * @return OK
     */
    roadworks(abm: string | undefined, roadway: string | undefined, rfb: number | undefined): Observable<RoadworkDto[]> {
        let url_ = this.baseUrl + "/api/v1/Roadworks?";
        if (abm === null)
            throw new Error("The parameter 'abm' cannot be null.");
        else if (abm !== undefined)
            url_ += "abm=" + encodeURIComponent("" + abm) + "&";
        if (roadway === null)
            throw new Error("The parameter 'roadway' cannot be null.");
        else if (roadway !== undefined)
            url_ += "roadway=" + encodeURIComponent("" + roadway) + "&";
        if (rfb === null)
            throw new Error("The parameter 'rfb' cannot be null.");
        else if (rfb !== undefined)
            url_ += "rfb=" + encodeURIComponent("" + rfb) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoadworks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoadworks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoadworkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoadworkDto[]>;
        }));
    }

    protected processRoadworks(response: HttpResponseBase): Observable<RoadworkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoadworkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return OK
     */
    nearestRoadworks(assetId: string | undefined): Observable<RoadworkDto[]> {
        let url_ = this.baseUrl + "/api/v1/Roadworks/nearestRoadworks?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNearestRoadworks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNearestRoadworks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoadworkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoadworkDto[]>;
        }));
    }

    protected processNearestRoadworks(response: HttpResponseBase): Observable<RoadworkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoadworkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roadworkId (optional) 
     * @return OK
     */
    sections(roadworkId: string | undefined): Observable<RoadworkSectionDto[]> {
        let url_ = this.baseUrl + "/api/v1/Sections?";
        if (roadworkId === null)
            throw new Error("The parameter 'roadworkId' cannot be null.");
        else if (roadworkId !== undefined)
            url_ += "roadworkId=" + encodeURIComponent("" + roadworkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoadworkSectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoadworkSectionDto[]>;
        }));
    }

    protected processSections(response: HttpResponseBase): Observable<RoadworkSectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoadworkSectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param appType (optional) 
     * @return OK
     */
    login(appType: string | undefined, body: LoginRequest): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/v1/User/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "appType": appType !== undefined && appType !== null ? "" + appType : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param appType (optional) 
     * @return OK
     */
    refreshtoken(appType: string | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/v1/User/refreshtoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "appType": appType !== undefined && appType !== null ? "" + appType : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshtoken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshtoken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processRefreshtoken(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param appType (optional) 
     * @return OK
     */
    logout(appType: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/User/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "appType": appType !== undefined && appType !== null ? "" + appType : "",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AbmDto implements IAbmDto {
    name?: string | undefined;

    constructor(data?: IAbmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AbmDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IAbmDto {
    name?: string | undefined;
}

export class DigitalEquipmentDto implements IDigitalEquipmentDto {
    assetId!: string | undefined;
    assetName?: string | undefined;
    lat?: number;
    lon?: number;
    stationary?: boolean;
    isAssigned?: boolean;
    isLocationChanged?: boolean;

    constructor(data?: IDigitalEquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.stationary = _data["stationary"];
            this.isAssigned = _data["isAssigned"];
            this.isLocationChanged = _data["isLocationChanged"];
        }
    }

    static fromJS(data: any): DigitalEquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DigitalEquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["stationary"] = this.stationary;
        data["isAssigned"] = this.isAssigned;
        data["isLocationChanged"] = this.isLocationChanged;
        return data;
    }
}

export interface IDigitalEquipmentDto {
    assetId: string | undefined;
    assetName?: string | undefined;
    lat?: number;
    lon?: number;
    stationary?: boolean;
    isAssigned?: boolean;
    isLocationChanged?: boolean;
}

export class DigitalEquipmentRequest implements IDigitalEquipmentRequest {
    points?: PointDto[] | undefined;
    roadworkid?: string | undefined;

    constructor(data?: IDigitalEquipmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PointDto.fromJS(item));
            }
            this.roadworkid = _data["roadworkid"];
        }
    }

    static fromJS(data: any): DigitalEquipmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DigitalEquipmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["roadworkid"] = this.roadworkid;
        return data;
    }
}

export interface IDigitalEquipmentRequest {
    points?: PointDto[] | undefined;
    roadworkid?: string | undefined;
}

export class DigitalRoadworkDto implements IDigitalRoadworkDto {
    id?: number;
    roadworkId?: string | undefined;
    citsState?: string | undefined;
    notificationStart?: Date | undefined;
    digitalEquipmentStart?: string | undefined;
    digitalEquipmentEnd?: string | undefined;
    order?: number;
    sectionType?: string | undefined;
    sectionId?: number | undefined;
    speed?: number | undefined;
    isDismantling?: boolean;
    canRoadworkBeAutomaticallyClosed?: boolean | undefined;
    latStart?: number | undefined;
    lonStart?: number | undefined;
    latEnd?: number | undefined;
    lonEnd?: number | undefined;
    kmStart?: number | undefined;
    kmEnd?: number | undefined;
    manualOffsetMeter?: number | undefined;
    isAutomaticallyStarted?: boolean | undefined;
    isAutomaticallyClosed?: boolean | undefined;
    hdop?: number;
    pdop?: number;
    trace?: PointDto[] | undefined;

    constructor(data?: IDigitalRoadworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roadworkId = _data["roadworkId"];
            this.citsState = _data["citsState"];
            this.notificationStart = _data["notificationStart"] ? new Date(_data["notificationStart"].toString()) : <any>undefined;
            this.digitalEquipmentStart = _data["digitalEquipmentStart"];
            this.digitalEquipmentEnd = _data["digitalEquipmentEnd"];
            this.order = _data["order"];
            this.sectionType = _data["sectionType"];
            this.sectionId = _data["sectionId"];
            this.speed = _data["speed"];
            this.isDismantling = _data["isDismantling"];
            this.canRoadworkBeAutomaticallyClosed = _data["canRoadworkBeAutomaticallyClosed"];
            this.latStart = _data["latStart"];
            this.lonStart = _data["lonStart"];
            this.latEnd = _data["latEnd"];
            this.lonEnd = _data["lonEnd"];
            this.kmStart = _data["kmStart"];
            this.kmEnd = _data["kmEnd"];
            this.manualOffsetMeter = _data["manualOffsetMeter"];
            this.isAutomaticallyStarted = _data["isAutomaticallyStarted"];
            this.isAutomaticallyClosed = _data["isAutomaticallyClosed"];
            this.hdop = _data["hdop"];
            this.pdop = _data["pdop"];
            if (Array.isArray(_data["trace"])) {
                this.trace = [] as any;
                for (let item of _data["trace"])
                    this.trace!.push(PointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DigitalRoadworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new DigitalRoadworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roadworkId"] = this.roadworkId;
        data["citsState"] = this.citsState;
        data["notificationStart"] = this.notificationStart ? this.notificationStart.toISOString() : <any>undefined;
        data["digitalEquipmentStart"] = this.digitalEquipmentStart;
        data["digitalEquipmentEnd"] = this.digitalEquipmentEnd;
        data["order"] = this.order;
        data["sectionType"] = this.sectionType;
        data["sectionId"] = this.sectionId;
        data["speed"] = this.speed;
        data["isDismantling"] = this.isDismantling;
        data["canRoadworkBeAutomaticallyClosed"] = this.canRoadworkBeAutomaticallyClosed;
        data["latStart"] = this.latStart;
        data["lonStart"] = this.lonStart;
        data["latEnd"] = this.latEnd;
        data["lonEnd"] = this.lonEnd;
        data["kmStart"] = this.kmStart;
        data["kmEnd"] = this.kmEnd;
        data["manualOffsetMeter"] = this.manualOffsetMeter;
        data["isAutomaticallyStarted"] = this.isAutomaticallyStarted;
        data["isAutomaticallyClosed"] = this.isAutomaticallyClosed;
        data["hdop"] = this.hdop;
        data["pdop"] = this.pdop;
        if (Array.isArray(this.trace)) {
            data["trace"] = [];
            for (let item of this.trace)
                data["trace"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDigitalRoadworkDto {
    id?: number;
    roadworkId?: string | undefined;
    citsState?: string | undefined;
    notificationStart?: Date | undefined;
    digitalEquipmentStart?: string | undefined;
    digitalEquipmentEnd?: string | undefined;
    order?: number;
    sectionType?: string | undefined;
    sectionId?: number | undefined;
    speed?: number | undefined;
    isDismantling?: boolean;
    canRoadworkBeAutomaticallyClosed?: boolean | undefined;
    latStart?: number | undefined;
    lonStart?: number | undefined;
    latEnd?: number | undefined;
    lonEnd?: number | undefined;
    kmStart?: number | undefined;
    kmEnd?: number | undefined;
    manualOffsetMeter?: number | undefined;
    isAutomaticallyStarted?: boolean | undefined;
    isAutomaticallyClosed?: boolean | undefined;
    hdop?: number;
    pdop?: number;
    trace?: PointDto[] | undefined;
}

export class IdDto implements IIdDto {
    id?: string | undefined;

    constructor(data?: IIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IIdDto {
    id?: string | undefined;
}

export class LogErrorDto implements ILogErrorDto {
    errorMessage?: string | undefined;

    constructor(data?: ILogErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): LogErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ILogErrorDto {
    errorMessage?: string | undefined;
}

export class LoginRequest implements ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;
}

export class MonitoringException implements IMonitoringException {
    message?: string | undefined;
    details?: string | undefined;

    constructor(data?: IMonitoringException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): MonitoringException {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["details"] = this.details;
        return data;
    }
}

export interface IMonitoringException {
    message?: string | undefined;
    details?: string | undefined;
}

export class MonitoringReport implements IMonitoringReport {
    entries?: { [key: string]: MonitoringReportEntry; } | undefined;
    status?: string | undefined;
    totalDuration?: string;
    itServiceId?: number;
    timestamp?: Date;

    constructor(data?: IMonitoringReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["entries"]) {
                this.entries = {} as any;
                for (let key in _data["entries"]) {
                    if (_data["entries"].hasOwnProperty(key))
                        (<any>this.entries)![key] = _data["entries"][key] ? MonitoringReportEntry.fromJS(_data["entries"][key]) : new MonitoringReportEntry();
                }
            }
            this.status = _data["status"];
            this.totalDuration = _data["totalDuration"];
            this.itServiceId = _data["itServiceId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MonitoringReport {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entries) {
            data["entries"] = {};
            for (let key in this.entries) {
                if (this.entries.hasOwnProperty(key))
                    (<any>data["entries"])[key] = this.entries[key] ? this.entries[key].toJSON() : <any>undefined;
            }
        }
        data["status"] = this.status;
        data["totalDuration"] = this.totalDuration;
        data["itServiceId"] = this.itServiceId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMonitoringReport {
    entries?: { [key: string]: MonitoringReportEntry; } | undefined;
    status?: string | undefined;
    totalDuration?: string;
    itServiceId?: number;
    timestamp?: Date;
}

export class MonitoringReportEntry implements IMonitoringReportEntry {
    data?: { [key: string]: any; } | undefined;
    description?: string | undefined;
    duration?: string;
    exception?: MonitoringException;
    status?: string | undefined;
    tags?: string[] | undefined;
    itServiceId?: number;
    timestamp?: Date;
    severity?: number;
    forwardToServiceDesk?: boolean;
    resolutionHint?: string | undefined;

    constructor(data?: IMonitoringReportEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.description = _data["description"];
            this.duration = _data["duration"];
            this.exception = _data["exception"] ? MonitoringException.fromJS(_data["exception"]) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.itServiceId = _data["itServiceId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.severity = _data["severity"];
            this.forwardToServiceDesk = _data["forwardToServiceDesk"];
            this.resolutionHint = _data["resolutionHint"];
        }
    }

    static fromJS(data: any): MonitoringReportEntry {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringReportEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["exception"] = this.exception ? this.exception.toJSON() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["itServiceId"] = this.itServiceId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["severity"] = this.severity;
        data["forwardToServiceDesk"] = this.forwardToServiceDesk;
        data["resolutionHint"] = this.resolutionHint;
        return data;
    }
}

export interface IMonitoringReportEntry {
    data?: { [key: string]: any; } | undefined;
    description?: string | undefined;
    duration?: string;
    exception?: MonitoringException;
    status?: string | undefined;
    tags?: string[] | undefined;
    itServiceId?: number;
    timestamp?: Date;
    severity?: number;
    forwardToServiceDesk?: boolean;
    resolutionHint?: string | undefined;
}

export class NotificationDto implements INotificationDto {
    text?: string | undefined;
    digitalRoadworks!: DigitalRoadworkDto[] | undefined;
    assignedDigitalEquipmentAtStart!: DigitalEquipmentDto;
    roadwork!: RoadworkDto;
    roadworkSections!: RoadworkSectionDto[] | undefined;
    nearbyDigitalEquipments?: DigitalEquipmentDto[] | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignedDigitalEquipmentAtStart = new DigitalEquipmentDto();
            this.roadwork = new RoadworkDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["digitalRoadworks"])) {
                this.digitalRoadworks = [] as any;
                for (let item of _data["digitalRoadworks"])
                    this.digitalRoadworks!.push(DigitalRoadworkDto.fromJS(item));
            }
            this.assignedDigitalEquipmentAtStart = _data["assignedDigitalEquipmentAtStart"] ? DigitalEquipmentDto.fromJS(_data["assignedDigitalEquipmentAtStart"]) : new DigitalEquipmentDto();
            this.roadwork = _data["roadwork"] ? RoadworkDto.fromJS(_data["roadwork"]) : new RoadworkDto();
            if (Array.isArray(_data["roadworkSections"])) {
                this.roadworkSections = [] as any;
                for (let item of _data["roadworkSections"])
                    this.roadworkSections!.push(RoadworkSectionDto.fromJS(item));
            }
            if (Array.isArray(_data["nearbyDigitalEquipments"])) {
                this.nearbyDigitalEquipments = [] as any;
                for (let item of _data["nearbyDigitalEquipments"])
                    this.nearbyDigitalEquipments!.push(DigitalEquipmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.digitalRoadworks)) {
            data["digitalRoadworks"] = [];
            for (let item of this.digitalRoadworks)
                data["digitalRoadworks"].push(item.toJSON());
        }
        data["assignedDigitalEquipmentAtStart"] = this.assignedDigitalEquipmentAtStart ? this.assignedDigitalEquipmentAtStart.toJSON() : <any>undefined;
        data["roadwork"] = this.roadwork ? this.roadwork.toJSON() : <any>undefined;
        if (Array.isArray(this.roadworkSections)) {
            data["roadworkSections"] = [];
            for (let item of this.roadworkSections)
                data["roadworkSections"].push(item.toJSON());
        }
        if (Array.isArray(this.nearbyDigitalEquipments)) {
            data["nearbyDigitalEquipments"] = [];
            for (let item of this.nearbyDigitalEquipments)
                data["nearbyDigitalEquipments"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationDto {
    text?: string | undefined;
    digitalRoadworks: DigitalRoadworkDto[] | undefined;
    assignedDigitalEquipmentAtStart: DigitalEquipmentDto;
    roadwork: RoadworkDto;
    roadworkSections: RoadworkSectionDto[] | undefined;
    nearbyDigitalEquipments?: DigitalEquipmentDto[] | undefined;
}

export class PointDto implements IPointDto {
    lat?: number;
    lon?: number;

    constructor(data?: IPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): PointDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface IPointDto {
    lat?: number;
    lon?: number;
}

export class RoadCoordinateDto implements IRoadCoordinateDto {
    latitude?: number;
    longitude?: number;
    km?: number;

    constructor(data?: IRoadCoordinateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.km = _data["km"];
        }
    }

    static fromJS(data: any): RoadCoordinateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadCoordinateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["km"] = this.km;
        return data;
    }
}

export interface IRoadCoordinateDto {
    latitude?: number;
    longitude?: number;
    km?: number;
}

export class RoadDto implements IRoadDto {
    id?: string | undefined;
    startKm?: number;
    endKm?: number;
    roadCode?: string | undefined;
    roadCodeShortTxt?: string | undefined;
    roadLongTxt?: string | undefined;
    roadDestination1?: string | undefined;
    roadDestination2?: string | undefined;

    constructor(data?: IRoadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startKm = _data["startKm"];
            this.endKm = _data["endKm"];
            this.roadCode = _data["roadCode"];
            this.roadCodeShortTxt = _data["roadCodeShortTxt"];
            this.roadLongTxt = _data["roadLongTxt"];
            this.roadDestination1 = _data["roadDestination1"];
            this.roadDestination2 = _data["roadDestination2"];
        }
    }

    static fromJS(data: any): RoadDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startKm"] = this.startKm;
        data["endKm"] = this.endKm;
        data["roadCode"] = this.roadCode;
        data["roadCodeShortTxt"] = this.roadCodeShortTxt;
        data["roadLongTxt"] = this.roadLongTxt;
        data["roadDestination1"] = this.roadDestination1;
        data["roadDestination2"] = this.roadDestination2;
        return data;
    }
}

export interface IRoadDto {
    id?: string | undefined;
    startKm?: number;
    endKm?: number;
    roadCode?: string | undefined;
    roadCodeShortTxt?: string | undefined;
    roadLongTxt?: string | undefined;
    roadDestination1?: string | undefined;
    roadDestination2?: string | undefined;
}

export class RoadworkDto implements IRoadworkDto {
    id?: string | undefined;
    roadworksReferenceId?: number | undefined;
    phaseReferenceId?: number | undefined;
    roadworkType?: string | undefined;
    roadworkName?: string | undefined;
    abm?: string | undefined;
    phaseDateStart?: string | undefined;
    phaseDateEnd?: string | undefined;
    roadworkDateStart?: string | undefined;
    roadworkDateEnd?: string | undefined;
    route?: string | undefined;
    direction?: number;
    beginInterchangeName?: string | undefined;
    endInterchangeName?: string | undefined;
    beginMeter?: number;
    endMeter?: number;
    lat?: number;
    lon?: number;
    vacatable?: boolean;
    phaseStateId?: number | undefined;
    citsState?: string | undefined;
    bmsState?: string | undefined;
    validityTime?: string | undefined;
    regulationPeriod?: string | undefined;
    icon?: string | undefined;
    areCoordinatesManuallySet?: boolean;
    isLongtermRoadwork?: boolean;
    belongsToCurrentUser?: boolean;

    constructor(data?: IRoadworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roadworksReferenceId = _data["roadworksReferenceId"];
            this.phaseReferenceId = _data["phaseReferenceId"];
            this.roadworkType = _data["roadworkType"];
            this.roadworkName = _data["roadworkName"];
            this.abm = _data["abm"];
            this.phaseDateStart = _data["phaseDateStart"];
            this.phaseDateEnd = _data["phaseDateEnd"];
            this.roadworkDateStart = _data["roadworkDateStart"];
            this.roadworkDateEnd = _data["roadworkDateEnd"];
            this.route = _data["route"];
            this.direction = _data["direction"];
            this.beginInterchangeName = _data["beginInterchangeName"];
            this.endInterchangeName = _data["endInterchangeName"];
            this.beginMeter = _data["beginMeter"];
            this.endMeter = _data["endMeter"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.vacatable = _data["vacatable"];
            this.phaseStateId = _data["phaseStateId"];
            this.citsState = _data["citsState"];
            this.bmsState = _data["bmsState"];
            this.validityTime = _data["validityTime"];
            this.regulationPeriod = _data["regulationPeriod"];
            this.icon = _data["icon"];
            this.areCoordinatesManuallySet = _data["areCoordinatesManuallySet"];
            this.isLongtermRoadwork = _data["isLongtermRoadwork"];
            this.belongsToCurrentUser = _data["belongsToCurrentUser"];
        }
    }

    static fromJS(data: any): RoadworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roadworksReferenceId"] = this.roadworksReferenceId;
        data["phaseReferenceId"] = this.phaseReferenceId;
        data["roadworkType"] = this.roadworkType;
        data["roadworkName"] = this.roadworkName;
        data["abm"] = this.abm;
        data["phaseDateStart"] = this.phaseDateStart;
        data["phaseDateEnd"] = this.phaseDateEnd;
        data["roadworkDateStart"] = this.roadworkDateStart;
        data["roadworkDateEnd"] = this.roadworkDateEnd;
        data["route"] = this.route;
        data["direction"] = this.direction;
        data["beginInterchangeName"] = this.beginInterchangeName;
        data["endInterchangeName"] = this.endInterchangeName;
        data["beginMeter"] = this.beginMeter;
        data["endMeter"] = this.endMeter;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["vacatable"] = this.vacatable;
        data["phaseStateId"] = this.phaseStateId;
        data["citsState"] = this.citsState;
        data["bmsState"] = this.bmsState;
        data["validityTime"] = this.validityTime;
        data["regulationPeriod"] = this.regulationPeriod;
        data["icon"] = this.icon;
        data["areCoordinatesManuallySet"] = this.areCoordinatesManuallySet;
        data["isLongtermRoadwork"] = this.isLongtermRoadwork;
        data["belongsToCurrentUser"] = this.belongsToCurrentUser;
        return data;
    }
}

export interface IRoadworkDto {
    id?: string | undefined;
    roadworksReferenceId?: number | undefined;
    phaseReferenceId?: number | undefined;
    roadworkType?: string | undefined;
    roadworkName?: string | undefined;
    abm?: string | undefined;
    phaseDateStart?: string | undefined;
    phaseDateEnd?: string | undefined;
    roadworkDateStart?: string | undefined;
    roadworkDateEnd?: string | undefined;
    route?: string | undefined;
    direction?: number;
    beginInterchangeName?: string | undefined;
    endInterchangeName?: string | undefined;
    beginMeter?: number;
    endMeter?: number;
    lat?: number;
    lon?: number;
    vacatable?: boolean;
    phaseStateId?: number | undefined;
    citsState?: string | undefined;
    bmsState?: string | undefined;
    validityTime?: string | undefined;
    regulationPeriod?: string | undefined;
    icon?: string | undefined;
    areCoordinatesManuallySet?: boolean;
    isLongtermRoadwork?: boolean;
    belongsToCurrentUser?: boolean;
}

export class RoadworkSectionDto implements IRoadworkSectionDto {
    roadworkId?: string | undefined;
    sectionId?: number;
    beginMeter?: number;
    endMeter?: number;
    blockedLanes?: string | undefined;
    usableLanes?: string | undefined;
    speed?: number;
    trace?: PointDto[] | undefined;

    constructor(data?: IRoadworkSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roadworkId = _data["roadworkId"];
            this.sectionId = _data["sectionId"];
            this.beginMeter = _data["beginMeter"];
            this.endMeter = _data["endMeter"];
            this.blockedLanes = _data["blockedLanes"];
            this.usableLanes = _data["usableLanes"];
            this.speed = _data["speed"];
            if (Array.isArray(_data["trace"])) {
                this.trace = [] as any;
                for (let item of _data["trace"])
                    this.trace!.push(PointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoadworkSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoadworkSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roadworkId"] = this.roadworkId;
        data["sectionId"] = this.sectionId;
        data["beginMeter"] = this.beginMeter;
        data["endMeter"] = this.endMeter;
        data["blockedLanes"] = this.blockedLanes;
        data["usableLanes"] = this.usableLanes;
        data["speed"] = this.speed;
        if (Array.isArray(this.trace)) {
            data["trace"] = [];
            for (let item of this.trace)
                data["trace"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoadworkSectionDto {
    roadworkId?: string | undefined;
    sectionId?: number;
    beginMeter?: number;
    endMeter?: number;
    blockedLanes?: string | undefined;
    usableLanes?: string | undefined;
    speed?: number;
    trace?: PointDto[] | undefined;
}

export class UserDto implements IUserDto {
    fullName!: string | undefined;
    loginName!: string | undefined;
    abms?: string | undefined;
    accessToken!: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.loginName = _data["loginName"];
            this.abms = _data["abms"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["loginName"] = this.loginName;
        data["abms"] = this.abms;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IUserDto {
    fullName: string | undefined;
    loginName: string | undefined;
    abms?: string | undefined;
    accessToken: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}